import React from 'react';
import {
    Box,
    Grid,
    GridProps,
    Text,
} from '@chakra-ui/react';
import { Image } from 'shared';
import { LeadForm } from '../../form';

export type LeadSectionProps = {
    className?: string;
    sidebar: {
        title: string
        subtitle?: string
    }
    image?: {
        url: string
    }
    title: string
    subtitle: string
    pdf?: {
        url: string
    }
} & GridProps & React.RefAttributes<HTMLDivElement>

export const LeadSection = ({
    sidebar,
    image,
    title,
    subtitle,
    pdf,
    ...props
}: LeadSectionProps) => (
    <Grid
        {...props}
        templateColumns={{
            base: '1fr',
            lg: 'auto 1fr 1fr',
        }}
        padding="2rem"
        gap="2rem"
    >
        <Grid
            gap="2rem"
            templateRows="auto 1fr auto"
            display={{
                base: 'none',
                lg: 'grid',
            }}
        >
            <Text
                color="white"
                margin="0 auto"
                fontSize="1.5rem"
                transform="rotate(-180deg)"
                fontWeight="light"
                writingMode="vertical-rl"
                textOrientation="mixed"
            >
                {sidebar.subtitle}
            </Text>
            <Box
                width="3px"
                margin="0 auto"
                background="white"
            />
            <Text
                color="white"
                margin="0 auto"
                fontSize="3rem"
                transform="rotate(-180deg)"
                fontWeight={900}
                writingMode="vertical-rl"
                textOrientation="mixed"
            >
                {sidebar.title}
            </Text>
        </Grid>
        <Grid
            display={{
                base: 'none',
                lg: 'grid',
            }}
        >
            <Image
                width="100%"
                height="100%"
                objectFit="cover"
                src={image?.url || ''}
            />
        </Grid>
        <LeadForm
            title={title}
            subtitle={subtitle}
            pdf={pdf}
        />
    </Grid>
);
